<script lang="ts">
  import { Button } from '$shared/components';
  import Label from '$provider/constants/Label';
  import type { ProfileMergeList } from '$provider/models/CaqhMergeList';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    item: ProfileMergeList;
    onclick?: (e: MouseEvent) => void;
  }

  let { item, onclick }: Props = $props();

  let label = $derived((item.props?.isConfirmed && Label.Reviewed) || Label.Review);
  let style = $derived((item.props?.isConfirmed && ButtonStyle.Secondary) || ButtonStyle.Primary);
</script>

<Button {style} {onclick}>{label}</Button>
